<template>
  <div>
    <div class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <a-checkbox
          :indeterminate="isIndeterminate"
          :checked="isAllChecked"
          @change="handleSelectAll"
          :disabled="!data || data.length === 0"
        >
          <span class="font-weight-bold">Select All ({{ selectedIds.length }}/{{ data.length }})</span>
        </a-checkbox>
        <span class="text-muted small" v-if="data && data.length > 0">
          Click row to preview
        </span>
      </div>

      <a-spin :spinning="loading">
        <div v-if="!loading && (!data || data.length === 0)" class="text-center py-4 text-muted">
          No records found.
        </div>
        <a-list v-else :dataSource="data" class="neo-list">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            :class="handleSelectedListClass(item.id)"
            @click="handleListClick(item)"
            class="idcard-list-item py-2 px-2"
          >
            <div class="d-flex align-items-center w-100">
              <div class="mr-2" @click.stop>
                <a-checkbox
                  :checked="selectedIds.includes(item.id)"
                  @change="(e) => handleCheckboxChange(item.id, e.target.checked)"
                />
              </div>

              <a-avatar
                :size="42"
                :src="item.photo"
                class="mr-2 flex-shrink-0"
                icon="user"
              />

              <div class="flex-grow-1 overflow-hidden">
                <div class="font-weight-bold text-truncate mb-0" style="font-size: 13.5px;">
                  {{ item.first_name }} {{ item.last_name }}
                </div>
                <div class="text-muted small text-truncate" v-if="mode === 'student'">
                  <span v-if="item.enrollment && item.enrollment.length > 0">
                    {{ item.enrollment[0].school_class ? item.enrollment[0].school_class.name : '' }}
                    <span v-if="item.enrollment[0].section">({{ item.enrollment[0].section.name }})</span>
                    <span v-if="item.enrollment[0].roll_no" class="ml-1">&bull; Roll: {{ item.enrollment[0].roll_no }}</span>
                  </span>
                  <span class="badge badge-light border ml-1">{{ item.student_code }}</span>
                </div>
                <div class="text-muted small text-truncate" v-else>
                  <span>{{ item.title || (item.staff_type ? item.staff_type.name : 'Staff') }}</span>
                  <span class="badge badge-light border ml-1">{{ item.staff_id }}</span>
                </div>
              </div>
            </div>
          </a-list-item>
        </a-list>
      </a-spin>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdCardList',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'student', // 'student' or 'staff'
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeId: null,
    }
  },
  computed: {
    isAllChecked() {
      if (!this.data || this.data.length === 0) return false
      return this.data.every((item) => this.selectedIds.includes(item.id))
    },
    isIndeterminate() {
      if (!this.data || this.data.length === 0) return false
      const checkedCount = this.data.filter((item) => this.selectedIds.includes(item.id)).length
      return checkedCount > 0 && checkedCount < this.data.length
    },
  },
  watch: {
    data(val) {
      if (!val || val.length === 0) {
        this.activeId = null
      }
    },
  },
  methods: {
    handleListClick(item) {
      this.activeId = item.id
      this.$emit('itemSelected', item)
    },
    handleCheckboxChange(id, isChecked) {
      let updated = [...this.selectedIds]
      if (isChecked) {
        if (!updated.includes(id)) updated.push(id)
      } else {
        updated = updated.filter((item) => item !== id)
      }
      this.$emit('update:selectedIds', updated)
    },
    handleSelectAll(e) {
      const isChecked = e.target.checked
      let updated = []
      if (isChecked) {
        updated = this.data.map((item) => item.id)
      }
      this.$emit('update:selectedIds', updated)
    },
    handleSelectedListClass(id) {
      return this.activeId === id ? 'neo-selected-list bg-light' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.neo-list {
  .idcard-list-item {
    cursor: pointer;
    border-radius: 6px;
    margin-bottom: 4px;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f0f0f0;

    &:hover {
      background-color: #f8fafc;
    }
  }
}
.neo-selected-list {
  background-color: #eff6ff !important;
  border-left: 3px solid #2563eb !important;
}
</style>
